<template lang="pug">
server-data(
  v-model="items"
  search-field-name="search[name]"
  :method="getEventMemberTypes"
  :start-loading-value="true"
  v-slot="{ loading: isLoading, search }"
)
  ev-autocomplete(
    v-model="inputValue"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    :items="filteredItems"
    :loading="isLoading"
    @update:search-input="search"
  )
</template>

<script>
import directoryService from '@/services/API/directories';
import { PER_PAGE } from '@/constants/pagination';

export default {
  constants: {
    PER_PAGE,
  },
  props: {
    value: {
      type: [Array, Number],
      required: false,
      default: () => [],
    },
    returnArray: {
      type: Boolean,
      default: false,
    },
    exclude: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(({ id }) => !this.exclude.includes(id));
    },
    inputValue: {
      // VADIM HOTFIX: Возвращаю и принимаю массив, есть ли требуется.
      // в будущем нужно изменить и логику на бэке и на фронте на единичное значение.
      // старые мероприятия могут вести себя не корректно, после этого фикса.
      // будет получаться всегда первый тип.
      get() {
        if (this.returnArray) {
          const [value] = this.value || [];
          return value || [];
        }
        return this.value;
      },
      set(val) {
        let value = val;
        if (this.returnArray) {
          value = [].concat(val || []);
        }
        this.$emit('input', value);
      },
    },
  },
  methods: {
    getEventMemberTypes(additionalParams = {}) {
      const params = {
        'per-page': this.$options.constants.PER_PAGE.infinity,
        sort: 'name',
      };

      return directoryService.getEventMemberTypes({ ...additionalParams, ...params });
    },
  },
};
</script>
